var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from "react";
import { generatePageHeaderName } from "@frameworks/salesjourney/components/Generic/TransparentHeader/TransparentHeader";
import { EChangedComponent, } from "@frameworks/salesjourney/components/Generic/ProductCategoryTabs/ProductCategoryTabs";
import "@frameworks/salesjourney/stylesheets/components/Features/ActivityBook/RM_Orderbook/AOP Investment/AOP_Investment_Main.scss";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import emptyFolder from "@frameworks/shared-library/assets/images/markets/emptyFolder.svg";
import ExcelPdfDownload from "../common/ExcelPdfDownload/ExcelPdfDownload";
import SearchPanelWithPopupFiltersLabel from "@frameworks/shared-library/components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
import AOPInvestment from "./AOP_Investment";
import AOP_Investment_Filters from "./AOP_Investment_Filters";
import moment from "moment";
import AOPInvestmentDates from "./AOP_Investment_Date";
import aopOrderBookDI from "./di/servicelocator";
import { useSelector } from "react-redux";
import filterDI from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import { getDateInFormat } from "@domains/utils/reportDates";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toCamelCase } from "@domains/utils/stringMethods";
import { EDataSource, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import { accountDetails } from "@mainDi/webDi";
import TextFirstAlphabetAsIcon from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/TextFirstAlphabetAsIcon";
import { randomColorArr } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
var defaultData = {
    dropDownList: [],
    tabsDataList: [],
    selectedDropdownObject: {
        label: "",
        value: "",
    },
    selectedTabEventKey: "1",
    selectedParent: {
        label: "",
        value: "",
    },
};
var AccountOpening = function (props) {
    var _a;
    var _b = __read(React.useState(false), 2), loader = _b[0], setLoader = _b[1];
    var _c = __read(React.useState([]), 2), rmNameFilterData = _c[0], setRMNameData = _c[1];
    var _d = __read(React.useState([]), 2), clientNameFilterData = _d[0], setClientNameData = _d[1];
    var _e = __read(React.useState([]), 2), originalClientNameFilterData = _e[0], setOriginalClientNameFilterData = _e[1];
    var _f = __read(React.useState({
        accountTypeId: ["2"],
        fromDate: moment().startOf("month").format("YYYY-MM-DD"),
        toDate: moment().format("YYYY-MM-DD"),
        pageStart: 0,
        pageSize: 10,
        isFilter: true,
        inputEmpId: [],
        inputClientCode: [],
    }), 2), filterData = _f[0], setFilterData = _f[1];
    var _g = __read(React.useState(), 2), retainedFilters = _g[0], setRetainedFiltersData = _g[1];
    var _h = __read(React.useState([]), 2), aopOrderbookDataList = _h[0], setAopOrderbookDataList = _h[1];
    var _j = __read(React.useState({}), 2), aopOrderbookMainEntity = _j[0], setAopOrderbookMainEntity = _j[1];
    var _k = __read(React.useState([]), 2), filtreLabels = _k[0], setFilterLabels = _k[1];
    var _l = __read(React.useState(defaultData), 2), aopOrderbookData = _l[0], setProductAopOrderbookData = _l[1];
    var _m = __read(React.useState(undefined), 2), mandatesFilters = _m[0], setMandatesFilters = _m[1];
    var _o = __read(React.useState(""), 2), searchValue = _o[0], setSearchValue = _o[1];
    var _p = __read(React.useState(false), 2), isShowFilterPopup = _p[0], setIsShowFilterPopup = _p[1];
    var _q = __read(React.useState(false), 2), excelDownloadLoader = _q[0], setExcelDownloadLoader = _q[1];
    var _r = __read(React.useState(false), 2), isShowExportPopup = _r[0], setIsShowExportPopup = _r[1];
    var getAOPOrderBookDashboardData = function (filterPageData) {
        setLoader(true);
        var reqObj = filterPageData
            ? filterPageData
            : filterData;
        reqObj.encryption = true;
        aopOrderBookDI.aopOrderBook
            .getAopOrderbookDashboard(reqObj)
            .then(function (resp) {
            var _a;
            if (!!resp) {
                setAopOrderbookMainEntity(resp);
                if (resp && ((_a = resp === null || resp === void 0 ? void 0 : resp.orderBookList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    setAopOrderbookDataList(resp === null || resp === void 0 ? void 0 : resp.orderBookList);
                }
                setLoader(false);
            }
            else {
                setAopOrderbookMainEntity({});
                setAopOrderbookDataList([]);
                setLoader(false);
            }
        })
            .catch(function (resp) {
            setLoader(false);
            setAopOrderbookMainEntity({});
            setAopOrderbookDataList([]);
        });
    };
    var profileData = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.Profile) === null || _a === void 0 ? void 0 : _a.ProfileDetails) === null || _b === void 0 ? void 0 : _b.reducersData) === null || _c === void 0 ? void 0 : _c.data; });
    var getCustomLabel = function (item) {
        var customLabel = "";
        customLabel = (React.createElement("div", { className: "primary-client-names-with-client-codes-container-bubble d-flex align-items-center gap-10 ".concat("") },
            " ",
            React.createElement(TextFirstAlphabetAsIcon, { textToExtractWordFrom: item === null || item === void 0 ? void 0 : item.display, textAndBackgroundColorCollection: randomColorArr })));
        return customLabel;
    };
    var truncateName = function (name) {
        return name.length > 15 ? name.slice(0, 12) + "..." : name;
    };
    var setFiltreLabelsUI = function (filterData) {
        var _a, _b, _c, _d;
        console.log("inputClientCode1", filterData, originalClientNameFilterData);
        var localFilterLabels = [
            {
                title: "Investment Account",
                disable: false,
                value: "2",
                keyName: "accountTypeId",
                subKeyName: "accountTypeId",
            },
        ];
        if (!!filterData) {
            localFilterLabels = [];
            localFilterLabels = [
                {
                    title: "Investment Account",
                    disable: false,
                    value: "2",
                    keyName: "accountTypeId",
                    subKeyName: "accountTypeId",
                },
            ];
            if (originalClientNameFilterData &&
                (originalClientNameFilterData === null || originalClientNameFilterData === void 0 ? void 0 : originalClientNameFilterData.length) > 0) {
                var clientNameFilterDataLocal_1 = [];
                if (((_a = filterData === null || filterData === void 0 ? void 0 : filterData.inputClientCode) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    (_b = filterData === null || filterData === void 0 ? void 0 : filterData.inputClientCode) === null || _b === void 0 ? void 0 : _b.map(function (record1) {
                        var recordFound = originalClientNameFilterData === null || originalClientNameFilterData === void 0 ? void 0 : originalClientNameFilterData.find(function (remote) { var _a; return ((_a = remote === null || remote === void 0 ? void 0 : remote.value) === null || _a === void 0 ? void 0 : _a.toString()) === record1; });
                        clientNameFilterDataLocal_1.push(recordFound);
                    });
                }
                if ((clientNameFilterDataLocal_1 === null || clientNameFilterDataLocal_1 === void 0 ? void 0 : clientNameFilterDataLocal_1.length) > 0)
                    clientNameFilterDataLocal_1 === null || clientNameFilterDataLocal_1 === void 0 ? void 0 : clientNameFilterDataLocal_1.map(function (record) {
                        var _a, _b;
                        var recordObj = {
                            title: (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "d-flex flex-row add-gap" },
                                    getCustomLabel(record),
                                    " ",
                                    React.createElement("span", { className: "DMsanL_12_300 txt-han-blue", title: toCamelCase(record === null || record === void 0 ? void 0 : record.display) }, truncateName(toCamelCase(record === null || record === void 0 ? void 0 : record.display))),
                                    React.createElement("span", { className: "DMsanR_09_400 txt_medium-gray" },
                                        "\u25CF",
                                        " ",
                                        ((_a = String(record === null || record === void 0 ? void 0 : record.value)) === null || _a === void 0 ? void 0 : _a.endsWith("I"))
                                            ? (_b = String(record === null || record === void 0 ? void 0 : record.value)) === null || _b === void 0 ? void 0 : _b.slice(0, -1)
                                            : record === null || record === void 0 ? void 0 : record.value,
                                        " ",
                                        "\u25CF Client")))),
                            disable: false,
                            value: record === null || record === void 0 ? void 0 : record.value,
                            keyName: "inputClientCode",
                            subKeyName: "inputClientCode",
                        };
                        localFilterLabels.push(recordObj);
                    });
            }
            if (rmNameFilterData && (rmNameFilterData === null || rmNameFilterData === void 0 ? void 0 : rmNameFilterData.length) > 0) {
                var rmNameData_1 = [];
                if (((_c = filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                    (_d = filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) === null || _d === void 0 ? void 0 : _d.filter(function (item) { return item !== undefined && item !== null; }).map(function (record1) {
                        var recordFound = rmNameFilterData === null || rmNameFilterData === void 0 ? void 0 : rmNameFilterData.find(function (remote) { var _a; return ((_a = remote === null || remote === void 0 ? void 0 : remote.value) === null || _a === void 0 ? void 0 : _a.toString()) === record1; });
                        rmNameData_1.push(recordFound);
                    });
                }
                if ((rmNameData_1 === null || rmNameData_1 === void 0 ? void 0 : rmNameData_1.length) > 0)
                    rmNameData_1 === null || rmNameData_1 === void 0 ? void 0 : rmNameData_1.map(function (record) {
                        var recordObj = {
                            title: (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "d-flex flex-row add-gap" },
                                    getCustomLabel(record),
                                    React.createElement("span", { className: "DMsanL_12_300 txt-han-blue", title: toCamelCase(record === null || record === void 0 ? void 0 : record.display) }, truncateName(toCamelCase(record === null || record === void 0 ? void 0 : record.display))),
                                    React.createElement("span", { className: "DMsanR_09_400 txt_medium-gray" },
                                        "\u25CF ", record === null || record === void 0 ? void 0 :
                                        record.value,
                                        " \u25CF RM")))),
                            disable: false,
                            value: record === null || record === void 0 ? void 0 : record.value,
                            keyName: "inputEmpId",
                            subKeyName: "inputEmpId",
                        };
                        localFilterLabels.push(recordObj);
                    });
                //  filterData?.inputClientCode?.map(())
            }
        }
        else {
            localFilterLabels = [];
            localFilterLabels = [
                {
                    title: "Investment Account",
                    disable: false,
                    value: "2",
                    keyName: "accountTypeId",
                    subKeyName: "accountTypeId",
                },
            ];
            if (clientNameFilterData && (clientNameFilterData === null || clientNameFilterData === void 0 ? void 0 : clientNameFilterData.length) > 0) {
                clientNameFilterData === null || clientNameFilterData === void 0 ? void 0 : clientNameFilterData.map(function (record) {
                    var _a, _b;
                    var recordObj = {
                        title: (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "d-flex flex-row add-gap" },
                                getCustomLabel(record),
                                React.createElement("span", { className: "DMsanL_12_300 txt-han-blue", title: toCamelCase(record === null || record === void 0 ? void 0 : record.display) }, truncateName(toCamelCase(record === null || record === void 0 ? void 0 : record.display))),
                                React.createElement("span", { className: "DMsanR_09_400 txt_medium-gray" },
                                    "\u25CF",
                                    ((_a = String(record === null || record === void 0 ? void 0 : record.value)) === null || _a === void 0 ? void 0 : _a.endsWith("I"))
                                        ? (_b = String(record === null || record === void 0 ? void 0 : record.value)) === null || _b === void 0 ? void 0 : _b.slice(0, -1)
                                        : record === null || record === void 0 ? void 0 : record.value,
                                    " ",
                                    "\u25CF Client")))),
                        disable: false,
                        value: record === null || record === void 0 ? void 0 : record.value,
                        keyName: "inputClientCode",
                        subKeyName: "inputClientCode",
                    };
                    localFilterLabels.push(recordObj);
                });
            }
            if (rmNameFilterData && (rmNameFilterData === null || rmNameFilterData === void 0 ? void 0 : rmNameFilterData.length) > 0) {
                var rmNameData = rmNameFilterData === null || rmNameFilterData === void 0 ? void 0 : rmNameFilterData.filter(function (item) { return item !== undefined && item !== null; }).filter(function (filterDatas) { var _a; return ((_a = filterDatas === null || filterDatas === void 0 ? void 0 : filterDatas.value) === null || _a === void 0 ? void 0 : _a.toString()) === (filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId[0]); });
                if ((rmNameData === null || rmNameData === void 0 ? void 0 : rmNameData.length) > 0)
                    rmNameData === null || rmNameData === void 0 ? void 0 : rmNameData.map(function (record) {
                        var recordObj = {
                            title: (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "d-flex flex-column add-gap" },
                                    React.createElement("span", { className: "DMsanL_12_300 txt-han-blue", title: toCamelCase(record === null || record === void 0 ? void 0 : record.display) }, truncateName(toCamelCase(record === null || record === void 0 ? void 0 : record.display))),
                                    React.createElement("span", { className: "DMsanR_09_400 txt_medium-gray" },
                                        "\u25CF", record === null || record === void 0 ? void 0 :
                                        record.value,
                                        " \u25CF RM")))),
                            disable: false,
                            value: record === null || record === void 0 ? void 0 : record.value,
                            keyName: "inputEmpId",
                            subKeyName: "inputEmpId",
                        };
                        localFilterLabels.push(recordObj);
                    });
                //  filterData?.inputClientCode?.map(())
            }
        }
        setFilterLabels(localFilterLabels);
    };
    var selectedColumns = [
        "accountCode",
        "clientName",
        "leadId",
        "clientEntity",
        "kycStatus",
        "dateTime",
        "displayStatus",
    ];
    var selectedColumnsHeader = [
        "Application Id",
        "Client Name",
        "Lead Id",
        "Client Entity",
        "Kyc Status",
        "date",
        "Status",
    ];
    var getRmFiltersData = function (searchText) {
        var reqObj = {
            filterData: { teamType: [1, 2], dataSource: EDataSource.RM, rmId: [] },
            page: "0",
            pageSize: "100",
        };
        if (!!searchText && searchText !== "")
            reqObj.searchText = searchText;
        filterDI.filter
            .getFilterDataActions(reqObj)
            .then(function (resp) {
            var _a;
            if (resp && ((_a = resp === null || resp === void 0 ? void 0 : resp.filterData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setRMNameData(function () {
                    var _a;
                    return (_a = resp === null || resp === void 0 ? void 0 : resp.filterData) === null || _a === void 0 ? void 0 : _a.map(function (filterObj) {
                        return {
                            display: filterObj === null || filterObj === void 0 ? void 0 : filterObj.name,
                            value: filterObj === null || filterObj === void 0 ? void 0 : filterObj.id,
                        };
                    });
                });
            }
            else {
                setRMNameData([]);
            }
        })
            .catch(function (resp) {
            setRMNameData([]);
        });
    };
    var getAOPClientFilterData = function () {
        var empId = "";
        if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) !== undefined) {
            empId = filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId.filter(function (item) { return item !== undefined && item !== null; }).join(",");
        }
        var reqObj = {
            fromDate: getDateInFormat(filterData === null || filterData === void 0 ? void 0 : filterData.fromDate, "yyyy-MM-DD"),
            toDate: getDateInFormat(filterData === null || filterData === void 0 ? void 0 : filterData.toDate, "yyyy-MM-DD"),
            accountTypeId: "2",
            inputEmpId: empId,
            encryption: true,
        };
        aopOrderBookDI.aopOrderBook
            .getAOPOrderBookClientFilterList(reqObj)
            .then(function (resp) {
            var _a;
            console.log("inputClientCode res 1", resp, reqObj);
            if (resp && ((_a = resp === null || resp === void 0 ? void 0 : resp.aopOrderBookClientList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setClientNameData(function () {
                    var _a;
                    return (_a = resp === null || resp === void 0 ? void 0 : resp.aopOrderBookClientList) === null || _a === void 0 ? void 0 : _a.map(function (filterObj) {
                        return {
                            display: toCamelCase(filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientname),
                            value: filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientcode,
                        };
                    });
                });
                setOriginalClientNameFilterData(function () {
                    var _a;
                    return (_a = resp === null || resp === void 0 ? void 0 : resp.aopOrderBookClientList) === null || _a === void 0 ? void 0 : _a.map(function (filterObj) {
                        return {
                            display: toCamelCase(filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientname),
                            value: filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientcode,
                        };
                    });
                });
            }
        })
            .catch(function () {
            setClientNameData([]);
            // setFiltreLabelsUI();
        });
    };
    useEffect(function () {
        var _a;
        !!props.setHeaderLeftComponent &&
            props.setHeaderLeftComponent(React.createElement("div", { className: "d-flex align-items-center gap-4" }, generatePageHeaderName("Order Book")));
        if (!!profileData &&
            !!(profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) &&
            !!((_a = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _a === void 0 ? void 0 : _a.userId)) {
            setFilterData(function (filterData) {
                var _a, _b;
                if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) == null ||
                    (filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) == undefined) {
                    filterData.inputEmpId = [];
                }
                filterData.inputEmpId.push((_b = (_a = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _a === void 0 ? void 0 : _a.userId) === null || _b === void 0 ? void 0 : _b.toString());
                var newSet = new Set(filterData.inputEmpId);
                filterData.inputEmpId = __spreadArray([], __read(newSet), false);
                return filterData;
            });
        }
        else {
            setUserID();
        }
        setTimeout(function () {
            getAOPOrderBookDashboardData();
        }, 200);
    }, []);
    var setUserID = function () { return __awaiter(void 0, void 0, void 0, function () {
        var userId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, accountDetails.getSalesuserId()];
                case 1:
                    userId = _a.sent();
                    if (userId) {
                        setFilterData(function (filterData) {
                            if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) == null ||
                                (filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) == undefined) {
                                filterData.inputEmpId = [];
                            }
                            filterData.inputEmpId.push(userId.toString());
                            var newSet = new Set(filterData.inputEmpId);
                            filterData.inputEmpId = __spreadArray([], __read(newSet), false);
                            return filterData;
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        setTimeout(function () {
            getRmFiltersData();
            getAOPClientFilterData();
        }, 2000);
        if (!!profileData &&
            !!(profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) &&
            !!((_a = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _a === void 0 ? void 0 : _a.userId)) {
            setFilterData(function (filterData) {
                var _a, _b;
                if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) == null ||
                    (filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) == undefined) {
                    filterData.inputEmpId = [];
                }
                filterData.inputEmpId.push((_b = (_a = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _a === void 0 ? void 0 : _a.userId) === null || _b === void 0 ? void 0 : _b.toString());
                var newSet = new Set(filterData.inputEmpId);
                filterData.inputEmpId = __spreadArray([], __read(newSet), false);
                return filterData;
            });
        }
    }, [profileData, filterData]);
    var handleUpdateSummaryFilters = function (data) {
        setAopOrderbookDataList([]);
        var localFilterData = __assign({}, filterData);
        localFilterData.pageSize = 10;
        localFilterData.fromDate = data === null || data === void 0 ? void 0 : data.fromDate;
        localFilterData.toDate = data === null || data === void 0 ? void 0 : data.toDate;
        if (localFilterData.inputEmpId == undefined) {
            localFilterData.inputEmpId = [];
        }
        getAOPOrderBookDashboardData(localFilterData);
        setFilterData(localFilterData);
        handleUpdateFilterPopupState(false);
    };
    var handleApplyFilters = function (latestFiltersData, comingFromFilter) {
        setAopOrderbookDataList([]);
        if (comingFromFilter !== null &&
            comingFromFilter !== undefined &&
            comingFromFilter) {
            var localFilterData = __assign({}, latestFiltersData);
            localFilterData.isFilter = true;
            if (localFilterData.inputEmpId == undefined) {
                localFilterData.inputEmpId = [];
            }
            setFilterData(localFilterData);
            getAOPOrderBookDashboardData(localFilterData);
            handleUpdateFilterPopupState(false);
        }
        else {
            var localFilterData = __assign({}, filterData);
            localFilterData.isFilter = true;
            localFilterData.fromDate = latestFiltersData === null || latestFiltersData === void 0 ? void 0 : latestFiltersData.fromDate;
            localFilterData.toDate = latestFiltersData === null || latestFiltersData === void 0 ? void 0 : latestFiltersData.toDate;
            if (localFilterData.inputEmpId == undefined) {
                localFilterData.inputEmpId = [];
            }
            setFilterData(localFilterData);
            getAOPOrderBookDashboardData(localFilterData);
            handleUpdateFilterPopupState(false);
        }
    };
    var handleUpdateMandateFilterData = function (data) {
        setMandatesFilters(data);
    };
    var handleDownloadExcel = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setExcelDownloadLoader(true);
            setTimeout(function () {
                exportToExcel();
            }, 2000);
            return [2 /*return*/];
        });
    }); };
    var handleClearAllFilters = function () {
        var _a, _b, _c;
        setAopOrderbookDataList([]);
        setFilterLabels([]);
        setRetainedFiltersData(null);
        var localFilterData = {
            fromDate: (filterData === null || filterData === void 0 ? void 0 : filterData.fromDate) || moment().startOf("month").format("YYYY-MM-DD"),
            toDate: (filterData === null || filterData === void 0 ? void 0 : filterData.toDate) || moment().format("YYYY-MM-DD"),
            pageStart: 0,
            pageSize: 10,
            isFilter: true,
            accountTypeId: ["2"],
        };
        if (!!profileData &&
            !!(profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) &&
            !!((_a = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _a === void 0 ? void 0 : _a.userId)) {
            if ((localFilterData === null || localFilterData === void 0 ? void 0 : localFilterData.inputEmpId) == null ||
                (localFilterData === null || localFilterData === void 0 ? void 0 : localFilterData.inputEmpId) == undefined) {
                localFilterData.inputEmpId = [];
            }
            localFilterData.inputEmpId.push((_c = (_b = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _b === void 0 ? void 0 : _b.userId) === null || _c === void 0 ? void 0 : _c.toString());
            localFilterData === null || localFilterData === void 0 ? void 0 : localFilterData.inputEmpId.filter(function (item) { return item !== undefined && item !== null; }).join(",");
            var newSet = new Set(localFilterData.inputEmpId);
            localFilterData.inputEmpId = __spreadArray([], __read(newSet), false);
        }
        setFilterData(localFilterData);
        // let localFilterLabels: Array<IFilterLabelsProps> = [
        //   {
        //     title: "Investment Account",
        //     disable: false,
        //     value: "2",
        //     keyName: "accountTypeId",
        //     subKeyName: "accountTypeId",
        //   },
        // ];
        // if (rmNameFilterData && rmNameFilterData?.length > 0) {
        //   let rmNameData: Array<IDisplayList> = rmNameFilterData?.filter(
        //     (filterDatas) =>
        //       filterDatas?.value?.toString() === filterData?.inputEmpId[0]
        //   );
        //   if (rmNameData?.length > 0)
        //     rmNameData?.map((record) => {
        //       let recordObj = {
        //         title: (
        //           <>
        //             <div className="d-flex flex-row add-gap">
        //               <span className="DMsanL_12_300 txt-han-blue">
        //                 {toCamelCase(record?.display)}
        //               </span>
        //               <span className="DMsanR_09_400 txt_medium-gray">
        //                 {record?.value} | RM
        //               </span>
        //             </div>
        //           </>
        //         ),
        //         disable: false,
        //         value: record?.value,
        //         keyName: "inputEmpId",
        //         subKeyName: "inputEmpId",
        //       };
        //       localFilterLabels.push(recordObj);
        //     });
        //   //  filterData?.inputClientCode?.map(())
        // }
        // setFilterLabels(localFilterLabels);
        getAOPOrderBookDashboardData(localFilterData);
        setIsShowFilterPopup(false);
    };
    var handleCancelFilters = function () {
        var localFilterData = __assign({}, filterData);
        if (localFilterData.inputEmpId == undefined) {
            localFilterData.inputEmpId = [];
        }
        setFilterData(localFilterData);
        setIsShowFilterPopup(false);
    };
    var clearSearching = function () {
        setSearchValue("");
        setAopOrderbookDataList(aopOrderbookMainEntity === null || aopOrderbookMainEntity === void 0 ? void 0 : aopOrderbookMainEntity.orderBookList);
    };
    var handleSearchFunds = function (searchText) {
        setSearchValue(searchText);
        setAopOrderbookDataList(function (aopOrderbookDataList) {
            if (!!searchText && searchText !== "") {
                var localSearchArray = aopOrderbookDataList;
                if ((aopOrderbookDataList === null || aopOrderbookDataList === void 0 ? void 0 : aopOrderbookDataList.length) == 0) {
                    localSearchArray = aopOrderbookMainEntity === null || aopOrderbookMainEntity === void 0 ? void 0 : aopOrderbookMainEntity.orderBookList;
                }
                var localData = searchInArray(localSearchArray, searchText, [
                    "clientName",
                    "accountCode",
                    "leadId",
                    "clientEntity",
                    "kycStatus",
                    "dateTime",
                    "displayStatus",
                    "status",
                ]);
                aopOrderbookDataList = localData;
            }
            else {
                aopOrderbookDataList = aopOrderbookMainEntity === null || aopOrderbookMainEntity === void 0 ? void 0 : aopOrderbookMainEntity.orderBookList;
            }
            return aopOrderbookDataList;
        });
    };
    var handleUpdateFilterPopupState = function (data) {
        setIsShowFilterPopup(data);
    };
    var searchInArray = function (arr, searchText, possibleKeys) {
        var localArray = arr.filter(function (obj) {
            // Create a mapped array of boolean values, checking if each key contains the searchTerm
            var matches = possibleKeys.map(function (key) {
                return obj[key] &&
                    obj[key].toString().toLowerCase().includes(searchText.toLowerCase());
            });
            // Return true if any of the keys match
            return matches.some(function (match) { return match; });
        });
        return localArray;
    };
    var generateTabContentList = function () {
        var localTabsList = [
            {
                title: "Investment Account",
                value: "1",
                eventKey: "1",
                tabContent: generateMainTabContent("1", aopOrderbookData, "", ""),
            },
        ];
        return localTabsList;
    };
    var exportToExcel = function () {
        // Create a new workbook
        var pageSize = Math.ceil(aopOrderbookMainEntity.totalRecord / 10) * 10;
        var selectedColumns = [
            "leadid",
            "applicationno",
            "cliententity",
            "kycstatus",
            "clientname",
            "applicationstatus",
            "laststagedropout",
            "qcassignedto",
            "qcassigneddt",
            "qcstatus",
            "qcapprovaldate",
            "pushedtobackofficedate",
            "accountopeningdate",
            "qcrejectdate",
            "noofrejections",
            "rejectionreason",
            // "selfie_link",
            // "ipvlink",
            // "esignlink",
            "dpid",
            "demataccountnumber",
        ];
        var selectedColumnsHeader = [
            "Lead Id",
            "Application No",
            "Client Entity",
            "Client KYC Status (KRA / Digilocker / Normal)",
            "Client Name",
            "Application Status",
            "Last Stage (Drop Out Stage)",
            "QC Assigned To",
            "QC Assigned Date",
            "Qc Status",
            "QC Approval Date",
            "Pushed to Back Office Date/I beats Status Updated date",
            "Account Opening Date",
            "Rejection Date",
            "Number of Rejections",
            "Rejection Reason",
            "DP Code",
            "Demat Account Number",
        ];
        var localFilterData = JSON.parse(JSON.stringify(filterData));
        localFilterData.pageSize = pageSize;
        localFilterData === null || localFilterData === void 0 ? void 0 : localFilterData.inputEmpId.filter(function (item) { return item !== undefined && item !== null; }).join(",");
        var reqObj = localFilterData;
        reqObj.encryption = true;
        aopOrderBookDI.aopOrderBook
            .getDownloadAOPOrderbookList(reqObj)
            .then(function (resp) {
            var _a;
            if (!!resp) {
                if (resp && ((_a = resp === null || resp === void 0 ? void 0 : resp.downloadList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    var dataWithHeader = __spreadArray([
                        selectedColumnsHeader
                    ], __read(resp === null || resp === void 0 ? void 0 : resp.downloadList.map(function (row) {
                        return selectedColumns.map(function (col) {
                            return col === "applicationno" &&
                                typeof row[col] === "string" &&
                                row[col].endsWith("I")
                                ? row[col].slice(0, -1)
                                : row[col];
                        });
                    })), false);
                    var ws = XLSX.utils.aoa_to_sheet(dataWithHeader);
                    var wb = XLSX.utils.book_new(); // Create a new workbook
                    XLSX.utils.book_append_sheet(wb, ws, "Sheet1"); // Append the sheet to the workbook
                    // Write the workbook to binary data
                    var excelBuffer = XLSX.write(wb, {
                        bookType: "xlsx",
                        type: "array",
                    });
                    // Convert the binary data to a Blob and trigger the file download
                    var file = new Blob([excelBuffer], {
                        type: "application/octet-stream",
                    });
                    saveAs(file, "AOP_INVESMENT_" +
                        getDateInFormat(new Date(), "DD/MM/YY") +
                        ".xlsx"); // File name is 'data.xlsx'
                    setExcelDownloadLoader(false);
                    setIsShowExportPopup(false);
                }
            }
            else {
                setExcelDownloadLoader(false);
                setIsShowExportPopup(false);
            }
        })
            .catch(function (resp) {
            setExcelDownloadLoader(false);
            setIsShowExportPopup(false);
        });
        // const ws = XLSX.utils.json_to_sheet(aopOrderbookDataList); // Convert the JSON data to a worksheet
    };
    var removeFilterThroughLabelsFunc = function (value, keyName, subKeyName) {
        console.log("value", value, keyName, subKeyName);
        setFilterLabels(function (filtreLabels) {
            if (value !== null && value !== undefined) {
                var findIndexValue = filtreLabels.findIndex(function (index) { return index.value === value; });
                if (findIndexValue > -1) {
                    filtreLabels.splice(findIndexValue, 1);
                }
            }
            return filtreLabels;
        });
        switch (keyName) {
            case "accountTypeId":
                break;
            case "inputEmpId":
                setFilterData(function (filterData) {
                    setAopOrderbookDataList([]);
                    setRetainedFiltersData(filterData);
                    if (value !== null && value !== undefined) {
                        var findValue = filterData.inputEmpId
                            .filter(function (item) { return item !== undefined && item !== null; })
                            .findIndex(function (code) { return code == value; });
                        if (findValue > -1) {
                            filterData.inputEmpId.splice(findValue, 1);
                            getAOPOrderBookDashboardData(filterData);
                            handleUpdateFilterPopupState(false);
                        }
                    }
                    return filterData;
                });
                break;
            case "inputClientCode":
                setFilterData(function (filterData) {
                    setAopOrderbookDataList([]);
                    setRetainedFiltersData(filterData);
                    if (value !== null && value !== undefined) {
                        var findValue = filterData.inputClientCode
                            .filter(function (item) { return item !== undefined && item !== null; })
                            .findIndex(function (code) { return code == value; });
                        if (findValue > -1) {
                            filterData.inputClientCode.splice(findValue, 1);
                            getAOPOrderBookDashboardData(filterData);
                            handleUpdateFilterPopupState(false);
                        }
                    }
                    return filterData;
                });
                break;
        }
    };
    var generateMainTabContent = function (productId, prodSubProdData, dataFromAPI, filterLabels) {
        var _a;
        if (prodSubProdData === void 0) { prodSubProdData = aopOrderbookData; }
        switch (productId) {
            case "1":
                return (React.createElement(React.Fragment, null,
                    React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "mb-20 py-0", searchBarParentClassName: "w-400", searchValue: searchValue, clearSearching: clearSearching, applySearchedFilters: handleSearchFunds, isShowPopup: isShowFilterPopup, setIsShowPopup: handleUpdateFilterPopupState, placeholder: "Search by client name, type or status", rightSubComponent: React.createElement(React.Fragment, null,
                            React.createElement(ExcelPdfDownload, { excelDownloadLoader: excelDownloadLoader, handleExcelDownloadCallback: handleDownloadExcel, isShowExportPopup: isShowExportPopup, setIsShowExportPopup: setIsShowExportPopup }),
                            React.createElement(AOPInvestmentDates, { filtersData: filterData, handleFilterChangeCallback: handleUpdateSummaryFilters })), filterComponentInsidePopup: React.createElement(React.Fragment, null,
                            React.createElement(AOP_Investment_Filters, { filterData: filterData, handleCancelCallback: handleCancelFilters, handleClearAllCallback: handleClearAllFilters, handleApplyFilters: handleApplyFilters, originalFilterData: filterData })), filterLabels: filterLabels, removeFilterThroughLabels: removeFilterThroughLabelsFunc }),
                    React.createElement(AOPInvestment, { totalPages: (aopOrderbookMainEntity === null || aopOrderbookMainEntity === void 0 ? void 0 : aopOrderbookMainEntity.totalRecord) !== 0
                            ? aopOrderbookMainEntity === null || aopOrderbookMainEntity === void 0 ? void 0 : aopOrderbookMainEntity.totalRecord
                            : (_a = aopOrderbookMainEntity === null || aopOrderbookMainEntity === void 0 ? void 0 : aopOrderbookMainEntity.orderBookList) === null || _a === void 0 ? void 0 : _a.length, data: aopOrderbookDataList, searchFilterApplied: searchValue && searchValue !== "" && (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0
                            ? true
                            : false, getAOPDashboardData: getAOPOrderBookDashboardData, filterData: filterData, setFilterData: setFilterData, loader: loader })));
            default:
                return generateDefaultError();
        }
    };
    var generateDefaultError = function () {
        return (React.createElement("div", { className: "custom-error-state flexCenter" },
            React.createElement(Errormsg, { image: emptyFolder, msg: "No results found" })));
    };
    var handleUpdateProductCategoryData = function (data) {
        setProductAopOrderbookData(function () { return data; });
    };
    var handleSelectAndTabChangeCallback = function (selectedData, changedComponent
    // apiData: IMutualFundsMainCategoryEntitiy
    ) {
        switch (changedComponent) {
            case EChangedComponent.SELECT:
                {
                    var localSelectedData = selectedData;
                    // handleUpdateProductCategoryData(
                    //   handleUpdateSelectedProductData(localSelectedData)
                    // );
                }
                break;
            case EChangedComponent.TAB:
                {
                    var localSelectedData = selectedData;
                    handleUpdateProductCategoryData(__assign(__assign({}, aopOrderbookData), { selectedTabEventKey: localSelectedData }));
                }
                break;
        }
        setIsShowExportPopup(false);
    };
    useEffect(function () { }, []);
    var aopOrderbookTabsProps = {
        hideDropdownList: true,
        dropDownList: [
            {
                label: "just",
                value: "just",
            },
        ],
        tabsDataList: generateTabContentList(),
        selectedDropdownObject: {
            label: "just",
            value: "just",
        },
        selectedTabEventKey: aopOrderbookData.selectedTabEventKey,
        //   ...(isViewSpecificCategory && { backArrowButton }),
        selectAndTabChangeCallback: function (selectedData, changedComponent) {
            return handleSelectAndTabChangeCallback(selectedData, changedComponent
            // productCategoryAPIData
            );
        },
    };
    return (React.createElement("div", { className: "d-flex flex-column w-100 bg_white" },
        React.createElement("div", { className: "AOP_Investment_main-label" }, "Investment Account"),
        React.createElement("div", { className: "aop_investment_Main_Filter" },
            React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "mb-20 py-0", searchBarParentClassName: "w-400", searchValue: searchValue, clearSearching: clearSearching, applySearchedFilters: handleSearchFunds, isShowPopup: isShowFilterPopup, setIsShowPopup: handleUpdateFilterPopupState, placeholder: "Search by client name, code, lead Id, status", rightSubComponent: React.createElement(React.Fragment, null,
                    React.createElement(ExcelPdfDownload, { excelDownloadLoader: excelDownloadLoader, handleExcelDownloadCallback: handleDownloadExcel, isShowExportPopup: isShowExportPopup, setIsShowExportPopup: setIsShowExportPopup }),
                    React.createElement(AOPInvestmentDates, { filtersData: filterData, handleFilterChangeCallback: handleUpdateSummaryFilters })), filterComponentInsidePopup: React.createElement(React.Fragment, null,
                    React.createElement(AOP_Investment_Filters, { filterData: filterData, handleCancelCallback: handleCancelFilters, handleClearAllCallback: handleClearAllFilters, handleApplyFilters: handleApplyFilters, setRetainedFilterData: setRetainedFiltersData, setFiltreLabelsUI: setFiltreLabelsUI, retainedFilters: retainedFilters })), filterLabels: filtreLabels, removeFilterThroughLabels: removeFilterThroughLabelsFunc })),
        React.createElement(AOPInvestment, { totalPages: (aopOrderbookMainEntity === null || aopOrderbookMainEntity === void 0 ? void 0 : aopOrderbookMainEntity.totalRecord) !== 0
                ? aopOrderbookMainEntity === null || aopOrderbookMainEntity === void 0 ? void 0 : aopOrderbookMainEntity.totalRecord
                : (_a = aopOrderbookMainEntity === null || aopOrderbookMainEntity === void 0 ? void 0 : aopOrderbookMainEntity.orderBookList) === null || _a === void 0 ? void 0 : _a.length, data: aopOrderbookDataList, searchFilterApplied: searchValue && searchValue !== "" && (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0
                ? true
                : false, getAOPDashboardData: getAOPOrderBookDashboardData, filterData: filterData, setFilterData: setFilterData, loader: loader })));
};
export default AccountOpening;
